import { memo } from 'react';
import { IconPlay } from '@picsart/design-system/foundation/icons/IconPlay';
import { IconImageOutline } from '@picsart/design-system/foundation/icons/IconImageOutline';

import { optimizeImageUrl } from '@/utils/media/optimizeImageUrl';
import { PreviewMediaType } from '@/types';

import useStyles from './styles';
import type { SearchSuggestionRowProps } from './types';

const SearchSuggestionRow = ({
  item,
  categoryLabel,
  onClick,
}: SearchSuggestionRowProps) => {
  const classes = useStyles();
  const TypeIcon =
    item.mediaType === PreviewMediaType.VIDEO ? IconPlay : IconImageOutline;

  return (
    <button
      type="button"
      className={classes.row}
      // A hit with no source preset has nowhere to go — keep it visible but
      // inert rather than dropping it from the result count.
      disabled={!item.presetSlug}
      onClick={() => onClick(item)}
      data-testid={`search-suggestion-${item.id}`}
    >
      <img
        className={classes.thumbnail}
        src={optimizeImageUrl(item.posterUrl)}
        alt=""
        aria-hidden
        loading="lazy"
      />
      <span className={classes.text}>
        <span className={classes.title}>{item.title}</span>
        {categoryLabel && (
          <span className={classes.category}>
            <TypeIcon className={classes.typeIcon} fill="currentColor" />
            {categoryLabel}
          </span>
        )}
      </span>
    </button>
  );
};

export default memo(SearchSuggestionRow);
